"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const splide_1 = __importDefault(require("@splidejs/splide"));
require("@splidejs/splide/src/css/core/index.scss");
require("@splidejs/splide/src/css/template/default/index.scss");
require("@splidejs/splide/src/css/themes/default/index.scss");
const localize_1 = require("./localize");
// Should TECHNICALLY be maximum one per subpage (more doesn't make sense), but better safe than sorry.
const productTableSliders = Array.from(document.querySelectorAll('.gs1-product-table'));
if (productTableSliders) {
    document.addEventListener('DOMContentLoaded', function () {
        productTableSliders.forEach((productTableSlider) => {
            new splide_1.default(productTableSlider, {
                arrows: true,
                autoplay: false,
                direction: 'ltr',
                easing: 'ease-in-out',
                keyboard: true,
                lazyLoad: 'nearby',
                pagination: true,
                padding: '1rem',
                pauseOnHover: true,
                pauseOnFocus: true,
                rewind: false,
                start: 0,
                type: 'fade',
            }).on('pagination:mounted', function (data) {
                data.list.classList.add('splide__pagination--product-table');
                const totalPackages = data.items.length;
                data.items.forEach(function (item) {
                    item.button.textContent = `Paket ${item.page + 1}/${totalPackages}`;
                });
            }).mount();
        });
    });
}
const productTableWithExpander = Array.from(document.querySelectorAll('[data-gs1-product-table-with-expander]'));
if (productTableWithExpander) {
    productTableWithExpander.forEach((productTable) => {
        const expanderButton = productTable.querySelector('[data-gs1-product-table-expander-button]');
        const expanderButtonMobile = Array.from(productTable.querySelectorAll('[data-gs1-product-table-expander-button]'));
        const expanderButtonCallback = (event) => {
            const el = event.target;
            const btnText = el.closest('.btn').querySelector('.btntext');
            if (el.closest('.btn').querySelector('.icon').classList.contains('icon--arrow-up')) {
                el.closest('.btn').querySelector('.icon').classList.remove('icon--arrow-up');
                if (el.closest('.c-product-table').classList.contains('c-product-table-desktop')) {
                    // @ts-ignore
                    btnText.innerText = `${(0, localize_1.Localize)('product_table.expander_button.expand', 'Weitere Details einblenden')}`;
                }
                else {
                    // @ts-ignore
                    btnText.innerText = `${(0, localize_1.Localize)('product_table.expander_button.expand.mobile', 'Details einblenden')}`;
                }
            }
            else {
                el.closest('.btn').querySelector('.icon').classList.add('icon--arrow-up');
                if (el.closest('.c-product-table').classList.contains('c-product-table-desktop')) {
                    // @ts-ignore
                    btnText.innerText = `${(0, localize_1.Localize)('product_table.expander_button.collapse', 'Weitere Details ausblenden')}`;
                }
                else {
                    // @ts-ignore
                    btnText.innerText = `${(0, localize_1.Localize)('product_table.expander_button.collapse.mobile', 'Details ausblenden')}`;
                }
            }
            const productTableWithExpanderItems = Array.from(productTable.querySelectorAll('.c-product-table-with-expander__item'));
            productTableWithExpanderItems.forEach((productTableItem) => {
                if (productTableItem.classList.contains('c-product-table-with-expander__item--hidden')) {
                    productTableItem.classList.remove('c-product-table-with-expander__item--hidden');
                }
                else {
                    productTableItem.classList.add('c-product-table-with-expander__item--hidden');
                }
                if (productTableItem.closest('.c-product-table').classList.contains('c-product-table-desktop')) {
                    productTableItem.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
            });
        };
        expanderButton.addEventListener('click', expanderButtonCallback);
        expanderButtonMobile.forEach((mobileButton) => {
            mobileButton.addEventListener('click', expanderButtonCallback);
        });
    });
    document.addEventListener('DOMContentLoaded', () => {
        const infoIcon = document.querySelector('.icon--info');
        if (infoIcon) {
            // Highlight first info icon for 2 seconds to set focus on them
            infoIcon.classList.add('animation-blink-once');
            infoIcon.classList.add('icon-info--highlighted');
            // Remove class after 2 seconds.
            setTimeout(() => {
                infoIcon.classList.remove('icon-info--highlighted');
            }, 2000);
        }
    });
}
